module.exports = __webpack_public_path__ + "img/nitori kawashiro_lw.d3e7f52d.png";